var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAstro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 268.52 278.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#d95f5f;}.cls-3{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_8);}.cls-4{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45);}.cls-5{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_307);}.cls-6{fill:#f2c6d5;}.cls-16,.cls-6,.cls-7{mix-blend-mode:multiply;}.cls-7{fill:#ccb1e0;}.cls-8{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_8-2);}.cls-9{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-2);}.cls-10{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_8-3);}.cls-11{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-3);}.cls-12{fill:#4f92a8;}.cls-13{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-4);}.cls-14{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-5);}.cls-15{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13);}.cls-16{fill:#eddad3;}.cls-17{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-6);}.cls-18{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_52);}.cls-19{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_41);}.cls-20{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_52-2);}.cls-21{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_41-2);}.cls-22{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_12);}.cls-23{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_8-4);}.cls-24{fill:#d13b2d;}.cls-25,.cls-26,.cls-27,.cls-35{mix-blend-mode:screen;}.cls-25{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_395);}.cls-26{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_395-2);}.cls-27{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_395-3);}.cls-28{fill:#fbb03b;}.cls-29{fill:#ffe0aa;}.cls-30{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_8-5);}.cls-31{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-7);}.cls-32{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_41-3);}.cls-33{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-8);}.cls-34{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-9);}.cls-35{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_407);}.cls-36{fill:#f38457;}.cls-37{fill:#f7c772;}.cls-38{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_8-6);}.cls-39{fill:#f37777;}.cls-40{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-10);}.cls-41{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-11);}.cls-42{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_307-2);}.cls-43{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_307-3);}.cls-44{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-12);}.cls-45{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8",
    x1: 38.73,
    y1: 242.81,
    x2: 21.99,
    y2: 201.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#f5857e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f8a68e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fbbf9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fdd2a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffdca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe0aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45",
    x1: 32.66,
    y1: 204.13,
    x2: 38.3,
    y2: 222.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c7f91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#133a7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_307",
    x1: 10.81,
    y1: 203.37,
    x2: 22.18,
    y2: 252.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa492c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b1161a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8-2",
    x1: 155.82,
    y1: 116.85,
    x2: 96.76,
    y2: 72.78,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-2",
    x1: 98.29,
    y1: 101.67,
    x2: 120.04,
    y2: 101.67,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8-3",
    x1: 245.96,
    y1: 147.57,
    x2: 161,
    y2: 105.61,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-3",
    x1: 163.17,
    y1: 127.39,
    x2: 206.54,
    y2: 146.43,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-4",
    x1: 171.34,
    y1: 108.79,
    x2: 214.7,
    y2: 127.82,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-5",
    x1: 278.01,
    y1: 89.22,
    x2: 250.16,
    y2: 126.77,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13",
    x1: -24.44,
    y1: 12.06,
    x2: 22.1,
    y2: 2.41,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f97762"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fa856a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#fca67b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fdbf89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fed293"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ffdc99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe09b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-6",
    x1: 56.64,
    y1: -21.49,
    x2: -20.57,
    y2: 36.33,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_52",
    x1: 47.63,
    y1: -7.49,
    x2: -17.02,
    y2: -9.07,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2f7d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ccf3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#bbe8cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#a0d5c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#79bbb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#489a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43979c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_41",
    x1: 49.49,
    y1: -7.2,
    x2: -18.72,
    y2: -13.28,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bde8bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#95d0b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#74bda7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#67b5a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#70baa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#87c8ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#addeba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bde8bf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_52-2",
    x1: 46.75,
    y1: 28.33,
    x2: -17.9,
    y2: 26.74,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_52"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_41-2",
    x1: 22.01,
    y1: 48.34,
    x2: -29.42,
    y2: 17,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_12",
    x1: -34.01,
    y1: 1.29,
    x2: -11.27,
    y2: 1.16,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#f1695e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#f68f6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#faad7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#fdc385"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#fed08b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd48d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8-4",
    x1: -29.3,
    y1: 1.27,
    x2: -16.69,
    y2: 1.27,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_395",
    x1: 43.28,
    y1: -24.08,
    x2: 3.81,
    y2: 36.09,
    gradientTransform: "matrix(-0.76, -0.65, -0.65, 0.76, 200.62, 74.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1c2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_395-2",
    x1: 33.04,
    y1: -4.81,
    x2: 32.86,
    y2: 50.89,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_395"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_395-3",
    x1: 24.34,
    y1: -4.84,
    x2: 24.16,
    y2: 50.87,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_395"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8-5",
    x1: 83.86,
    y1: 36.18,
    x2: 109.06,
    y2: 1.8,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-7",
    x1: 71.6,
    y1: 32.47,
    x2: 105.45,
    y2: 73.19,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_41-3",
    x1: 70.72,
    y1: 48.35,
    x2: 101.26,
    y2: 48.35,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_41"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-8",
    x1: 82.94,
    y1: 23.04,
    x2: 116.79,
    y2: 63.76,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-9",
    x1: 87.49,
    y1: 55.2,
    x2: 64.75,
    y2: 53.62,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_407",
    x1: 86.37,
    y1: 17.96,
    x2: 85.58,
    y2: 51.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aed4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#637979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#1c2222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8-6",
    x1: 106.93,
    y1: 234.45,
    x2: 65.95,
    y2: 179.98,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-10",
    x1: 106.74,
    y1: 168.02,
    x2: 89.29,
    y2: 207.15,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-11",
    x1: 70.39,
    y1: 145.47,
    x2: 63.25,
    y2: 194.26,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_307-2",
    x1: 26.57,
    y1: 260.3,
    x2: 80.09,
    y2: 260.3,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_307"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_307-3",
    x1: 114,
    y1: 159.99,
    x2: 168.94,
    y2: 159.99,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_307"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-12",
    x1: 45.59,
    y1: 226.11,
    x2: 71.63,
    y2: 244.62,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45-13",
    x1: 35.42,
    y1: 240.41,
    x2: 61.47,
    y2: 258.92,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer_1-2",
    "data-name": "layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228,127.23a93,93,0,0,1,9.59,16.5,149.6,149.6,0,0,1-58,52.27c-10.36-.84-21.81-4-30.46-9.8,11.69-12.1,22.51-24.06,35.45-34.8S212.25,133.2,228,127.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47,231.37A42.57,42.57,0,0,1,32.6,249.9a36.9,36.9,0,0,1-3.22,2.16l-.37.19a5.54,5.54,0,0,1-1.22.43c-2.63.57-5.79-.64-8.22-1.91a12.65,12.65,0,0,1-6.67-8.22C9.8,231.27,5,220.61.8,209.66a7.9,7.9,0,0,1-.7-4.38,4.1,4.1,0,0,1,1.1-2,19.84,19.84,0,0,1,2.15-1.93,33.62,33.62,0,0,1,3.92-2.64c3.08-1.79,6.89-2.12,10.44-2.1a44.89,44.89,0,0,1,13.48,7,90.12,90.12,0,0,1,8.88,7.63l0,0c2.94-2.34,5.77-4.92,8.48-7.52a37.63,37.63,0,0,1,1.2,6.19A45.3,45.3,0,0,1,47,231.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39,222.73a56.8,56.8,0,0,0-8.16-7.27,20,20,0,0,0,.31-11.88,90.12,90.12,0,0,1,8.88,7.63l0,0A18.87,18.87,0,0,1,39,222.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M32.6,249.9a36.9,36.9,0,0,1-3.22,2.16l-.37.19c-2.82,1.38-6.62,0-9.44-1.48a12.65,12.65,0,0,1-6.67-8.22C9.8,231.27,5,220.61.8,209.66a7.9,7.9,0,0,1-.7-4.38,4.1,4.1,0,0,1,1.1-2,19.84,19.84,0,0,1,2.15-1.93c2.83-.14,6.22,1.19,8.36,2.43a26.84,26.84,0,0,1,7.8,7.33c7.82,10.46,10.56,23.76,12.81,36.63A14.61,14.61,0,0,1,32.6,249.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.46,252.48l-.44.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.78,252.67h0l.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.8,209.84c-3.84,1.34-6.51,5-10.39,6.28a39.55,39.55,0,0,1-5.53.88,20.86,20.86,0,0,0-6,2.08,41.56,41.56,0,0,0-5,3.08A9.33,9.33,0,0,0,20.46,224c1.71,3.54,3.3,7.13,4.74,10.78,2.19,5.58,4.07,11.47,3.81,17.43l.37-.19a36.9,36.9,0,0,0,3.22-2.16A42.57,42.57,0,0,0,47,231.37,45.3,45.3,0,0,0,49.8,209.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M29,252.25c-2.82,1.38-6.62,0-9.44-1.48a12.65,12.65,0,0,1-6.67-8.22C9.8,231.27,5,220.61.8,209.66a7.9,7.9,0,0,1-.7-4.38,6.62,6.62,0,0,1,4.8-.3,14.6,14.6,0,0,1,6.92,4.47,37.3,37.3,0,0,1,4.66,6.9,153.32,153.32,0,0,1,8.72,18.47C27.39,240.4,29.27,246.29,29,252.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164.66,102.54a7.14,7.14,0,0,1-1.2,4,25.51,25.51,0,0,1-13.36,10.35c-5,1.44-10.27-.06-15.2-1.62-5.3-1.68-10.59-3.44-15.75-5.53-.41-.17-.83-.33-1.24-.51-4.64-2-9.86-3.53-13.59-7.07-2.08-2-4.09-4.13-6-6.34-2.38-2.71-4.65-5.52-6.82-8.28a56.56,56.56,0,0,1-5.65-8.45,36.79,36.79,0,0,1-3.28-8.25,4.35,4.35,0,0,1,.77-3.46A10.92,10.92,0,0,1,86,64.83a43.17,43.17,0,0,1,15.79-7.24q2.34,1.59,4.51,3.41a61.18,61.18,0,0,1,13.93,16.5,5,5,0,0,1,3.29-.09,7,7,0,0,1,1.33,3.2c0,.64,5,1,5.8,1.22,2,.51,4,1.09,5.92,1.76a78.86,78.86,0,0,1,11,4.72,88.56,88.56,0,0,1,10.51,6.48,31.8,31.8,0,0,1,4.69,3.64A6.26,6.26,0,0,1,164.66,102.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M120,104c-.2,1.93-.56,3.82-.89,5.72-.41-.17-.83-.33-1.24-.51-4.64-2-9.86-3.53-13.59-7.07-2.08-2-4.09-4.13-6-6.34l4.93-2.14C108.5,97.76,113.84,101.47,120,104Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.25,101.43a3.25,3.25,0,0,1-1,2.1c-1.41,1.77-2.88,3.46-4.41,5.11-1.84,2-3.85,4-6.4,4.88-3,1.09-6.29.61-9.38-.08A74.92,74.92,0,0,1,92.39,80.72a29.2,29.2,0,0,1-6.57-1.67,36.79,36.79,0,0,1-3.28-8.25,4.35,4.35,0,0,1,.77-3.46A10.92,10.92,0,0,1,86,64.83a43.17,43.17,0,0,1,15.79-7.24q2.34,1.59,4.51,3.41a.69.69,0,0,1,0,.13c-.47,2.31-1.48,4.55-1.53,6.91a105.84,105.84,0,0,1,18.16,16,25.41,25.41,0,0,1-3,8l6.71-6.16a19.46,19.46,0,0,1,.55,6.84c1.15-1.94,2.6-3.55,3-5.78a80.31,80.31,0,0,1,28.23,12.09C159.28,99.64,160.22,100.4,160.25,101.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M268.52,109.31A43.63,43.63,0,0,1,260.3,128c-16.13,6.07-32.84,12.57-48.55,19.65a126.34,126.34,0,0,1-17.54,17.07A123.35,123.35,0,0,1,184,172.08a50.08,50.08,0,0,0-7.06,5c-2.51,2.29-5.89,4.42-9.38,3-2.21-11.32-9.9-20.55-19.12-27.47s-20-11.45-30.57-15.92c-.09-.91-.16-1.78-.19-2.6a17.64,17.64,0,0,1,1-6.82c5.82-2.55,11.5-5.57,17.57-7.43,9-7.06,16.86-16.24,26.57-22.71q2.11-1.41,4.35-2.63c12-6.52,24.71-11.89,37.06-17.83,8.12-3.91,16.33-7.19,25.25-8.47A133.09,133.09,0,0,1,268.52,109.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M178.54,122.8c2.86-.9,6.5-1,8.33,1.37,4,5.28-3.6,14.18-7.54,17.19a13.53,13.53,0,0,1-7.28,3c-8.67.47-8.56-8.42-4.74-13.7A21.77,21.77,0,0,1,178.54,122.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M169.5,131.87a5.72,5.72,0,0,0-.29,1.56,2.64,2.64,0,0,0,1.94,2.82,3.7,3.7,0,0,0,1.73-.31,21.63,21.63,0,0,0,9-5.92,4.27,4.27,0,0,0,1.26-3.2c-.54-3.72-5.32-2.32-7.51-1.44A11.41,11.41,0,0,0,169.5,131.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M182,136.31a47.67,47.67,0,0,0,10.23,1.35c2.47-4.75,4.27-10.52,6.74-15.28,3.75-2,8.24-3,11.51-5.72a21.88,21.88,0,0,0,7.25-10.37,6.76,6.76,0,0,1-3.46,0c-4,6.38-10.11,12-17.16,14.66-2.45,4.3-4.14,10-5.72,14.69-2.29.16-5.56-1.26-7.62-2.3C183.1,134.31,182.65,135.35,182,136.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M268.52,109.31A43.63,43.63,0,0,1,260.3,128c-3.95,1.49-7.94,3-11.94,4.54-12.32,4.76-24.75,9.77-36.61,15.11a126.34,126.34,0,0,1-17.54,17.07A123.35,123.35,0,0,1,184,172.08a50.08,50.08,0,0,0-7.06,5c-2.51,2.29-5.89,4.42-9.38,3-2.21-11.32-9.9-20.55-19.12-27.47s-20-11.45-30.57-15.92c-.09-.91-.16-1.78-.19-2.6,2.85.31,6,2.16,8.31,3q7.8,2.85,15.61,5.73a36,36,0,0,0-8.4-10.46,83.08,83.08,0,0,1,31,29.48,30.3,30.3,0,0,0,9.54,2.73c9.75-6.21,18.53-12.46,26.64-20.71a43.71,43.71,0,0,1,6-15.16c0,1.35.43,2.69.48,4a36.79,36.79,0,0,0,20-8.4c1.28.14,1.82.61,3.1.74a25,25,0,0,0,3.56-6.26,26,26,0,0,1-5.47-4.25c2,.12,4.1-.29,6.16-.16a4,4,0,0,0,0-2.48,32.68,32.68,0,0,1-7.78-4.56c-.59.47-1.34.75-1.92,1.22.28.93.21,1.86.49,2.81-1.31-.07-2.64-.12-4-.18l.12,2.22c-9.12,2.52-18.44,5.07-27.9,4.61-12-.58-30.75-7.28-30.41-20.92q2.11-1.41,4.35-2.63c12-6.52,24.71-11.89,37.06-17.83,8.12-3.91,16.33-7.19,25.25-8.47a133.22,133.22,0,0,1,33.68,33Q266,105.14,268.52,109.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M268.52,109.31A43.63,43.63,0,0,1,260.3,128c-3.95,1.49-7.94,3-11.94,4.54,0-1.88.16-3.87,0-5.64,2.07-2.34,4.16-4.48,6.23-6.82a49.56,49.56,0,0,1-1.83-11.69,64.51,64.51,0,0,1,10.38-7.2Q266,105.14,268.52,109.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M159.56,58.23A44.52,44.52,0,0,0,155,70.61c-1.74,8.41-.78,17,4.42,24a36.24,36.24,0,0,0,4.2,4.72,67.22,67.22,0,0,0,12.54,9.07c.75.46,1.52.9,2.28,1.34a35.44,35.44,0,0,0,24.05,4c13.66-2.63,24.18-13.39,28-26.39a38.3,38.3,0,0,0,1.45-8.2c.05-.67.06-1.34.07-2a36.56,36.56,0,0,0-.48-6.29,37.85,37.85,0,0,0-4.68-13A40.53,40.53,0,0,0,207.4,41c-.74-.31-1.46-.59-2.21-.85-8-2.79-17.69-3.69-25.56-.24l-.09,0-1.23.58-.64.31A42.71,42.71,0,0,0,159.56,58.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M177,107.44c-.27.32-.55.65-.81,1,.75.46,1.52.9,2.28,1.34a35.44,35.44,0,0,0,24.05,4c13.66-2.63,24.18-13.39,28-26.39A63.18,63.18,0,0,0,232,77.18c0-.2,0-.4,0-.61a16.1,16.1,0,0,0-.52-5.68,7.05,7.05,0,0,0-1.08-2.09c-2.54-3.36-7.84-3.34-11.47-1.21s-6.06,5.76-8.58,9.12a94.63,94.63,0,0,1-17.7,17.84C187.3,98.68,181.4,102.29,177,107.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M159.56,58.23A44.52,44.52,0,0,0,155,70.61c-1.74,8.41-.78,17,4.42,24a36.24,36.24,0,0,0,4.2,4.72,37.06,37.06,0,0,0,9.42,6.18,35,35,0,0,0,25.44,1.32,32.27,32.27,0,0,0,18.81-17,60,60,0,0,0-28.6-44.39,35.84,35.84,0,0,0-11-4.65A42.71,42.71,0,0,0,159.56,58.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M214.74,83.72A51.85,51.85,0,0,0,192.2,49.66C186,45.35,179.85,42.81,173,43.53l-1.82,1.3-.81-2.2S188.18,38.05,207,61.94c4.36,5.5,7.18,13.81,8.51,20.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M207,61.94c-18.86-23.89-36.65-19.31-36.65-19.31L178,38.5s17.8,1,30.27,18.89A64.3,64.3,0,0,1,218,81l-2.45,1.82C214.22,75.75,211.4,67.44,207,61.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M210.19,97.32a35,35,0,0,1-29.08,8.58c-10.51-1.62-19.88-8.53-25.19-17.76-.42.11-.81.47-1.24.58,3.87,5.36,8.25,11.12,13.92,14.53a32.2,32.2,0,0,0,20.85,3.86c14-1.18,21-8.72,21-8.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M168.6,103.25a32.2,32.2,0,0,0,20.85,3.86c14-1.18,21-8.72,21-8.72l-.12-.59,1,2.14c-6.5,8-17.37,11.81-27.56,10.57S164.23,103.26,158.15,95a38.41,38.41,0,0,1-3.47-6.28C158.55,94.08,162.93,99.84,168.6,103.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M210.44,91.83l-.06.25c-.76,3.24-.66,10.32,4.56,10a3.67,3.67,0,0,0,.75-.12,8.41,8.41,0,0,0,3.65-2.06,19.35,19.35,0,0,0,6.28-10.7c.49-2.57.68-6.74-2.08-8.34a4.07,4.07,0,0,0-.82-.36C216.67,78.46,211.59,87.37,210.44,91.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M210.44,91.83l-.06.25c-.76,3.24-.66,10.32,4.56,10a3.67,3.67,0,0,0,.75-.12A5.75,5.75,0,0,1,211.77,98a10.29,10.29,0,0,1,.08-5.74,17.41,17.41,0,0,1,8-10.47,5.69,5.69,0,0,1,3.73-1,4.07,4.07,0,0,0-.82-.36C216.67,78.46,211.59,87.37,210.44,91.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M216.52,92.29c-.37,1.11-.19,3.33,1.35,3.28s2.9-2,3.58-3.13a6.48,6.48,0,0,0,.82-3.83,1.56,1.56,0,0,0-.62-1.13c-1.05-.72-2.84.74-3.32,1.61a4.42,4.42,0,0,1,1.33-1,1.42,1.42,0,0,1,1.56.1,1.91,1.91,0,0,1,.29,1.89,9.52,9.52,0,0,1-1.89,3.77,2.17,2.17,0,0,1-1.85,1,1.45,1.45,0,0,1-1.06-1A2.87,2.87,0,0,1,216.52,92.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M172.68,45.24c-6.71,4.87-15.55,16.68-16.56,29.09a15.42,15.42,0,0,0,9.12,12.56,20.15,20.15,0,0,0,15.85-.12,29.47,29.47,0,0,0,12.36-10.31,55.56,55.56,0,0,0,7.06-14.63C194,52.57,183.88,45.45,172.68,45.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M168.5,70.05a5.72,5.72,0,0,1-3.64,1,4,4,0,0,1-2.78-2.29,8.54,8.54,0,0,1-.69-3.65,20.77,20.77,0,0,1,2.71-10.5,15.48,15.48,0,0,1,6.11-6.16,10.21,10.21,0,0,1,8.5-.54C191,53.05,174.12,67,168.5,70.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M157.52,79.32c1.33-7.49,10.26-.68,9.12,4.68-.57,2.67-2.43,7.28-5.59,4.56C158.69,86.53,157,82.38,157.52,79.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M63.73,28.94a12.69,12.69,0,0,1-1-10.28c1-3.22,3.28-6.21,6.49-7.22a11.16,11.16,0,0,1,5.93,0,12,12,0,0,1,4.93,2.33,9.8,9.8,0,0,1,3.35,7.59,12,12,0,0,1-3.21,7.75,15.77,15.77,0,0,1-6.88,4.18,8,8,0,0,1-6.73-1.37A9.8,9.8,0,0,1,63.73,28.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M66.87,29.77c2.42,2.23,6,2.18,8.78.68a10.87,10.87,0,0,0,5.3-9,9.67,9.67,0,0,0-1.44-5.86,7.12,7.12,0,0,0-4.94-2.75c-4.22-.61-8.2.81-10,4.92A10.91,10.91,0,0,0,66.87,29.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M91.35,27.25C93,21.49,95,15.85,96.59,10.09,102.38,8.76,108.4,6.59,114.3,6a2.08,2.08,0,0,0,1.62-1.81,3.6,3.6,0,0,0-.51-2.56A3.19,3.19,0,0,0,113.53,0,110.05,110.05,0,0,0,95.46,8.2L90.34,25.77C90.9,26.39,90.79,26.64,91.35,27.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M106.11,44.71a58.49,58.49,0,0,1-2,16c-.68,2.51-.34,5.28-.78,7.84-.6,3.47-4.6,5.59-8,6.34s-7,.33-10.5-.09c-4.72-.56-7-6.28-8.57-10.78s-1.81-9.32-2-14.06c0-1.46,0-3.05.86-4.2a5.33,5.33,0,0,1,3.09-1.67c4.89-1.09,10,.51,15-.09,2.2-.27,4.35-1,6.56-1.12S104.66,43,106.11,44.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M98.06,74.4a84.93,84.93,0,0,1-24.15,0l-3.19-51c10.55-2.44,20.81-2.72,30.54,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M73.14,31.85l2.38,41H96.94l1.41-41C88.39,27.09,78.23,35.05,73.14,31.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.88,74c-2.11,0-4.11-.26-6.22-.22a55.72,55.72,0,0,0,0-6.59,53.9,53.9,0,0,0-9.24-.73,94.64,94.64,0,0,1-1.56-21.12,3.05,3.05,0,0,1,.45-1.76,3.15,3.15,0,0,1,1.85-.9c3-.69,6-1.35,9-2V28.06a59.6,59.6,0,0,1,7.3.75c-.08,2.91,0,5.94-.07,8.85,1.87,2.75,3.32,5.7,5,8.56a23.09,23.09,0,0,1-4.83,2.63C93.89,56.94,92.93,65.9,92.88,74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M96.88,33.56a8.63,8.63,0,0,0-3.14,5.77,54.25,54.25,0,0,0,6.18,9.54c.15,1.17-.06,2.43.09,3.6a26.38,26.38,0,0,1,2.46-1.61,20.09,20.09,0,0,0,2.47-2.13,4.19,4.19,0,0,0,1.45-2.26c.21-1.23.18-2.54.27-3.78a28.35,28.35,0,0,0-5.47-4.27A14.39,14.39,0,0,1,96.88,33.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M87.42,61.72a6.11,6.11,0,0,0-1.94,1.33,10.46,10.46,0,0,1,.68,2.82,28.34,28.34,0,0,1-8.51,3.6l-.45.12a18.9,18.9,0,0,1-9.59-.17,31.33,31.33,0,0,1-.74-6.56c.24-.37.73-1,1.16-1.14a76.68,76.68,0,0,0-.49-11.54c0-.11,0-.22,0-.34l-1.87-.62,0,0a13.65,13.65,0,0,1-2-6.85c3.21-1.3,7.16-3.27,10.54-4.06a.72.72,0,0,1,.21,0A35.8,35.8,0,0,1,80.72,40c1.12-.15,2.59-.31,3.7-.46a14.72,14.72,0,0,1,1,5,16.43,16.43,0,0,1-7,2c-.67.7-1,1.4-1.65,2.1a53.75,53.75,0,0,1,9.26,2A33.16,33.16,0,0,1,87.42,61.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M74.58,44.94a3.34,3.34,0,0,1-1.64,1.12l-4.25,1.78-2.13.89c-.27.12-.61.31-1,.46a13.65,13.65,0,0,1-2-6.85c3.21-1.3,7.16-3.27,10.54-4.06a.72.72,0,0,1,.21,0,4.38,4.38,0,0,1,.2.94c.15,1.21.28,2.43.36,3.65A3.29,3.29,0,0,1,74.58,44.94Zm3.09,18.27A17.82,17.82,0,0,1,68.6,62a24.76,24.76,0,0,0,9.74-.27c-.19-1.53-.36-3.27-.55-4.81a30.73,30.73,0,0,1-8.13.11c2.54-.32,5.32-.79,7.85-1.11A25.88,25.88,0,0,0,76,49.37a30.5,30.5,0,0,0-8.47.81A76.68,76.68,0,0,1,68,61.72c-.43.12-.92.77-1.16,1.14a31.33,31.33,0,0,0,.74,6.56,18.9,18.9,0,0,0,9.59.17l.45-.12a5.81,5.81,0,0,0,.21-2.16A19.44,19.44,0,0,1,77.67,63.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M99.27,35.29c.43-3.29.89-6.91,1.32-10.2a63.11,63.11,0,0,0-28.77-.21q.18,6.5.91,13a28,28,0,0,1,4.64-.74C78,32.93,78.71,29.22,79.29,25a39.77,39.77,0,0,1,17.46,1c-.1,2.44-.27,5-.22,7.45C97.55,34.19,98.26,34.62,99.27,35.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M113.57,5a1.06,1.06,0,0,0,.36.37c.49.26.92-.28,1.09-.66a3.07,3.07,0,0,0,.14-2.21A2.94,2.94,0,0,0,113.44.69a.53.53,0,0,0-.41,0c-.55.24-.39,1.46-.35,1.92A5.06,5.06,0,0,0,113.57,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M65.32,23.12c-1.47,1.73.5,6.79,3.08,5.48A2.72,2.72,0,0,0,69.55,27a13.36,13.36,0,0,0,.67-3.07A1.12,1.12,0,0,0,70,23a1.15,1.15,0,0,0-.54-.27,7.81,7.81,0,0,0-2.18-.43A2.63,2.63,0,0,0,65.32,23.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M65.35,19.31c-.29-1.87,1.68-3.95,3.2-4.75a2.18,2.18,0,0,1,1-.29c1.83.07,2.7,2.94,2.69,4.37a3.08,3.08,0,0,1-3,3.24C67.74,21.79,65.62,21,65.35,19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M73.49,18.27a3.18,3.18,0,0,0,2.13,2.46A4.7,4.7,0,0,0,78.81,20,2.58,2.58,0,0,0,80,19a2.32,2.32,0,0,0-.3-2.13,6.24,6.24,0,0,0-2.63-2.63c-.9-.41-2.74-.73-3.4.28S73.28,17.35,73.49,18.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M168.94,180.47c-2,1.06-4.45,1.66-6.2,3.12-.18.14-.34.29-.52.42a292.81,292.81,0,0,1-49.36,33C102.6,222.53,92,227.5,81,232.23c0,.46-.07.92-.12,1.38-.22,2.79-.49,5.65-.81,8.6-.19,1.65-.39,3.33-.6,5-3.35,6.67-23.83,27.6-31.12,31.07A29.66,29.66,0,0,1,38,277.17a28.31,28.31,0,0,1-11.27-6.44c-.12-1.29-.2-2.58-.2-3.89,0-5.23,1.13-10.46,4.29-14.65,1.16-1.54,2.39-3,3.6-4.57a49.8,49.8,0,0,0,5.48-8c.37-.71.71-1.42,1-2.16.7-1.73,1.48-3.51,2.17-5.32a35.29,35.29,0,0,0,2.2-7.6c.09-.64.17-1.29.2-1.93.68-12.69.35-28.81,1-41.12a74.22,74.22,0,0,1,1.65-13.23c2.57-6.56,8-15.85,12.34-17.77l1.73-.51a208.79,208.79,0,0,1,41.51-7.46,48.54,48.54,0,0,1,5.92-5.16c1.28.23,2.82.27,4.1.5l.18-.11c1.11-.6,2.53-1.17,3.6-1.77,11,4.53,22.1,9.14,31.65,16.21a61.66,61.66,0,0,1,10.82,10.15A40.89,40.89,0,0,1,168.94,180.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M85.2,202.63a181.69,181.69,0,0,1-3.73,25.11,130.53,130.53,0,0,1,2-27C84.1,201.69,84.54,201.7,85.2,202.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M99.52,178.67c2.77-2.07,5.68-4,8.45-6.12a137.41,137.41,0,0,0-19.23,10.07C92.53,181.56,96.36,181,99.52,178.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M82.75,205.53a135.2,135.2,0,0,1,23.62-10.92A74.45,74.45,0,0,0,100,178.25a72.82,72.82,0,0,0-11.22,4.37A82.4,82.4,0,0,0,82.75,205.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M86.42,165.9a49.4,49.4,0,0,0-13.8,22.6,37.19,37.19,0,0,1-26.05-7,74.22,74.22,0,0,1,1.65-13.23c2.57-6.56,8-15.85,12.34-17.77l1.73-.51A32.52,32.52,0,0,1,86.42,165.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M80.09,242.21c-.19,1.65-.39,3.33-.6,5-3.35,6.67-23.83,27.6-31.12,31.07a28.75,28.75,0,0,1-21.6-7.6c-.12-1.29-.2-2.58-.2-3.89a39.87,39.87,0,0,0,19.87,7.46C59.6,265.58,70.45,254.42,80.09,242.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.07,162.33c-1.63,1.07-3,2.86-4.72,4.21A127.08,127.08,0,0,1,133.88,180c-2.79-1.95-6.25-3-9.53-3.86a38.55,38.55,0,0,1,4.84,6.92,98.83,98.83,0,0,1-18.36,11.72,123.6,123.6,0,0,1-20.07,7.81,33.53,33.53,0,0,1,1.52-16.75c6.1-4.48,12.45-8.69,19-12.6l1.38-.83-1.32.53a18.61,18.61,0,0,0-1-9.3,53.67,53.67,0,0,0-4.41-9c.29,2-.31,4,0,6-.76-1.53-2.44-2.53-3.21-4.05a131.9,131.9,0,0,0-28.24,13.27c-3.69,23.66-5.6,48.13-4.34,72-6.27,11.56-13.24,23.52-24.57,30.21A42.53,42.53,0,0,0,39.21,276,9.94,9.94,0,0,0,38,277.17a29.66,29.66,0,0,0,10.33,1.16c7.29-3.47,27.77-24.4,31.12-31.07.21-1.72.41-3.4.6-5,.32-3,.59-5.81.81-8.6,0-.46.08-.92.12-1.38,1.38-.59,2.74-1.19,4.11-1.79q4.26-1.86,8.42-3.8l3.11-1.45,3.5-1.68c.81-.39,1.63-.79,2.44-1.2,2.16-1.06,4.29-2.14,6.41-3.25,1.25-.64,2.51-1.29,3.75-2l.1-.05a293.27,293.27,0,0,0,49.88-33.45c1.75-1.46,4.17-2.06,6.2-3.12A40.89,40.89,0,0,0,160.07,162.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.27,173.49a45.47,45.47,0,0,0-11.64-6.37,45,45,0,0,0-5.06-12.36A90.54,90.54,0,0,1,126.27,173.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M168.94,180.47c-2,1.06-4.45,1.66-6.2,3.12-.18.14-.34.29-.52.42-2.75-9.17-6.17-18.31-12.92-25-3.89-3.84-8.66-6.61-13.41-9.28q-5.34-3-10.72-5.92c-3.84-2.08-7.52-3.82-11.17-6.11,1.11-.6,2.53-1.17,3.6-1.77,11,4.53,22.1,9.14,31.65,16.21a61.66,61.66,0,0,1,10.82,10.15A40.89,40.89,0,0,1,168.94,180.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M132.65,159.51l-20-9.59A26.28,26.28,0,0,1,132.65,159.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M66.06,232.13a33.75,33.75,0,0,1-3.26,9.25,29.17,29.17,0,0,1-19.68-9.25,35.29,35.29,0,0,0,2.2-7.6A62.88,62.88,0,0,0,66.06,232.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M58.24,250.56c-1.69,2.68-3.73,4.31-6.19,6.3a23.66,23.66,0,0,0-17.59-9.24,49.8,49.8,0,0,0,5.48-8A26.11,26.11,0,0,1,58.24,250.56Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstro);
export default __webpack_public_path__ + "static/media/astro.8f6eab3db0a2e825d759b135c713dc85.svg";
export { ForwardRef as ReactComponent };